import React from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Grid, 
  Card, 
  CardContent, 
  CardMedia, 
  IconButton,
  Stack 
} from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
// Eliminar cualquier importación de mockData si existe

const Equipo = () => {
  // Datos definidos localmente
  const teamMembers = [
    {
      name: 'Dr. Juan Carlos Martínez',
      role: 'Socio Director',
      specialty: 'Derecho Corporativo y Fusiones',
      description: 'Doctor en Derecho por la Universidad Complutense de Madrid. Más de 20 años de experiencia en asesoría corporativa internacional.',
      image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?q=80&w=1000',
      linkedin: 'https://linkedin.com',
      email: 'jcmartinez@bufetelegal.com'
    },
    {
      name: 'Dra. Ana María Sánchez',
      role: 'Socia - Derecho Laboral',
      specialty: 'Derecho Laboral y Seguridad Social',
      description: 'Especialista en negociaciones colectivas y reestructuraciones empresariales. Docente universitaria.',
      image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=1000',
      linkedin: 'https://linkedin.com',
      email: 'asanchez@bufetelegal.com'
    },
    {
      name: 'Dr. Roberto Torres',
      role: 'Socio - Litigios',
      specialty: 'Litigación y Arbitraje',
      description: 'Experto en resolución de conflictos comerciales complejos y arbitraje internacional.',
      image: 'https://images.unsplash.com/photo-1556157382-97eda2d62296?q=80&w=1000',
      linkedin: 'https://linkedin.com',
      email: 'rtorres@bufetelegal.com'
    }
  ];

  return (
    <Box sx={{ pt: 8 }}>
      <Box sx={{ bgcolor: 'primary.main', color: 'white', py: 8 }}>
        <Container>
          <Typography variant="h2" component="h1" gutterBottom>
            Nuestro Equipo
          </Typography>
          <Typography variant="h5">
            Profesionales comprometidos con la excelencia legal
          </Typography>
        </Container>
      </Box>

      <Container sx={{ py: 8 }}>
        <Grid container spacing={4}>
          {teamMembers.map((member) => (
            <Grid item key={member.name} xs={12} sm={6} md={4}>
              <Card 
                sx={{ 
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'transform 0.2s',
                  '&:hover': {
                    transform: 'translateY(-8px)'
                  }
                }}
              >
                <CardMedia
                  component="img"
                  height="300"
                  image={member.image}
                  alt={member.name}
                  sx={{ objectFit: 'cover' }}
                />
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography gutterBottom variant="h5" component="h2">
                    {member.name}
                  </Typography>
                  <Typography 
                    variant="subtitle1" 
                    color="primary" 
                    gutterBottom
                    sx={{ fontWeight: 'bold' }}
                  >
                    {member.role}
                  </Typography>
                  <Typography 
                    variant="subtitle2" 
                    color="text.secondary" 
                    gutterBottom
                  >
                    {member.specialty}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 2 }}>
                    {member.description}
                  </Typography>
                  <Stack direction="row" spacing={1}>
                    <IconButton 
                      href={member.linkedin} 
                      target="_blank"
                      color="primary"
                      size="small"
                    >
                      <LinkedInIcon />
                    </IconButton>
                    <IconButton 
                      href={`mailto:${member.email}`}
                      color="primary"
                      size="small"
                    >
                      <EmailIcon />
                    </IconButton>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Equipo;